import React, { useEffect, useState } from 'react';
import CircularProgressLoader from '../components/CircularProgressLoader';
import { useTranslation } from 'react-i18next';
import { DUROLT_ABOUT_URL } from '../assets/constants/Constants';

const AboutScreenPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('pleaseWaitText'));

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
            setLoadingMessage('');
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="about-screen-page">
            <div className="main-container">
                <div className="main">

                    {loading && (
                        <div>
                            <CircularProgressLoader message={loadingMessage} />
                        </div>
                    )}

                    <iframe
                        src={DUROLT_ABOUT_URL}
                        title="About Page"
                        className={`iframe-view ${loading ? 'hide' : ''}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default AboutScreenPage;